function Download() {
  return (
    <>
      <h1>Download</h1>
    </>
  );
}
export default Download;
